import PropTypes from 'prop-types';

import Festival from '../../../../../assets/images/icons/carfillo-festival.png';
import { ReactComponent as CouponsIcon } from './../../../../../assets/svg/coupons.svg';
import { ReactComponent as FireIcon } from './../../../../../assets/svg/fire.svg';
import { ReactComponent as StarIcon } from './../../../../../assets/svg/star.svg';
import styles from './Suggestion.module.css';

const list = [
  {
    type: 'festival',
    render: () => (
      <div className={styles.dynamiclabel}>
        <img alt="snapp" src={Festival} style={{ width: '55px' }} />
      </div>
    )
  },
  {
    type: 'special_offer',
    render: ({ children }) => (
      <div className={styles.dynamiclabel}>
        <StarIcon className={styles.SpetialOfferLogo} />
        <div className={styles.SpetialOfferText}>{children}</div>
      </div>
    )
  },
  {
    type: 'best_seller',
    render: ({ children }) => (
      <div className={styles.dynamiclabel}>
        <FireIcon className={styles.BestSellerLogo} />
        <div className={styles.BestSellerText}>{children}</div>
      </div>
    )
  },
  {
    type: 'discount_code',
    render: ({ children }) => (
      <div className={styles.dynamiclabel}>
        <CouponsIcon className={styles.DiscountCodeLogo} />
        <div className={styles.DiscountCodeText}>{children}</div>
      </div>
    )
  }
];

const Suggestion = ({ label = null, type = null }) => {
  if (type === null) {
    return null;
  }

  const SelectedSuggestion = list.find((listItem) => listItem.type === type)?.render;

  if (!SelectedSuggestion) {
    return null;
  }

  return <SelectedSuggestion>{label}</SelectedSuggestion>;
};

Suggestion.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string
};

export default Suggestion;
